<div class="patient-results-filter-form" [formGroup]="patientResultsFilterDetailsFormGroup">
    <div class="emds-col-12">
        <label [for]="baseId + '-group'" translate>
            Group
        </label>
        <div class="emds-row">
            <div class="emds-col-12">
                <div class="d-flex flex-row flex-wrap gap-5">
                    <mat-radio-group class="radio-group" formControlName="groupType">
                        <mat-radio-button *ngFor="let category of groupTypesList" [value]="category.controlName">
                            {{ category.label }}
                        </mat-radio-button>
                    </mat-radio-group>
                    <div class="emds-col-md-4">
                        <ap-findcontrol 
                            [singleSelect]="false" 
                            [baseId]="baseId + 'disclosure-reason'" 
                            [findControlId]="listObservationFindControlId"
                            [required]="false"
                            [additionalSearchParameters]="listObservationAdditionalParameters"
                            [disabled]="isObservationFindControlDisabled"
                            (chipsChange)="handleObservationChipChange($event)"
                            [apFormGroup]="patientResultsFilterDetailsFormGroup"
                            [controlName]="'templateUids'"
                        >
                        </ap-findcontrol>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="emds-col-12 mt-4">
        <label [for]="baseId + '-test-values'" translate>
            Test Values
        </label>
        <div class="checkbox-group d-flex flex-row flex-wrap gap-3">
            <ng-container *ngFor="let type of testTypesList">
                <mat-checkbox [id]="baseId + type.label" [disableRipple]="true" [formControlName]="type.controlName">
                    {{type.label}}
                </mat-checkbox>
            </ng-container>
        </div>
    </div>
    <div class="emds-col-12">
        <hr>
    </div>
    <div class="emds-row">
        <div class="emds-col-12 emds-col-md-3">
            <label [for]="baseId + '-medications'" translate>
                Medications
            </label>
            <div class="mt-2">
                <mat-checkbox [id]="baseId + 'medication-on-flowsheet'" [disableRipple]="true"
                    formControlName="showMedicationOnFlowSheet" translate>
                    <label translate class="wrap-text">
                        Show medications on Flowsheet
                    </label>
                </mat-checkbox>
            </div>
        </div>

        <div class="emds-col-12 emds-col-md-3">
            <div class="drug-selection-container">
                <ap-findcontrol 
                    [singleSelect]="false" 
                    [findControlDisplayName]="'Find Drug Name'"
                    [baseId]="baseId + '-drugs'" 
                    [findControlId]="drugsFindControlId" 
                    [required]="false"
                    [disabled]="isMedicationFindControlDisabled"
                    (chipsChange)="handleDrugsChipChange($event)"
                    [apFormGroup]="patientResultsFilterDetailsFormGroup"
                    [controlName]="'genericDrugUids'"
                ></ap-findcontrol>
            </div>
        </div>

        <div class="emds-col-12 emds-col-md-3">
            <label [for]="baseId + '-date-type'" translate>Date Type</label>
            <ap-findcontrol 
                [singleSelect]="true" 
                [baseId]="baseId + '-date-type'" 
                [findControlId]="dateTypeFindControlId" 
                [requiredSearchParameters]="dateTypeRequiredSearchParametersDto"
                [controlName]="'dateTypeUid'"
                [apFormGroup]="patientResultsFilterDetailsFormGroup"
            ></ap-findcontrol>
        </div>

        <div class="emds-col-12 emds-col-md-3">
            <label [for]="baseId + '-date-range'" translate>Date Range</label>
             <ap-timespan-find-control 
                [singleSelect]="true" 
                [baseId]="baseId + '-date-range'" 
                [selectedPks]="selectedTimeSpanIds"
                [findControlId]="findControlIdService.ListTimespan" 
                [required]="false"
                [customDateRange]="customDateRange"
                (selectedPksChange)="handleDateRangeSelectedPksChange($event)"
                (customDateRangeChange)="onCustomDateRangeChange($event)"
            >
            </ap-timespan-find-control>
        </div>
    </div>
    <div class="emds-col-12">
        <hr>
    </div>
    <div class="emds-row mt-2">
        <div class="emds-col-12 emds-col-md-4">
            <label [for]="baseId + 'maximum-item'" translate>
                Maximum Items Returned (-1 for no limit)
            </label>
            <input [id]="baseId + 'maximum-item'" [value]="" type="number" formControlName="maxItemsReturned"
                class="form-control" [ngClass]="{'error': isFormSubmitted && patientResultsFilterDetailsFormGroup.controls.maxItemsReturned.invalid}" />
            <div *ngIf="isFormSubmitted" class="incorrect-input">
                <div *ngIf="patientResultsFilterDetailsFormGroup.controls.maxItemsReturned.hasError('min')" translate>
                    Maximum Items should be greater than or equal to -1
                </div>
                <div *ngIf="patientResultsFilterDetailsFormGroup.controls.maxItemsReturned.hasError('max')" translate>
                    Maximum Items should be less than or equal to 10000
                </div>
            </div>
        </div>
        <div class="emds-col-12 emds-col-md-8">
            <div class="checkbox-group d-flex flex-row flex-wrap gap-3 mt-5" >
                <ng-container *ngFor="let option of FilterConfigOptionsList">
                    <mat-checkbox [id]="baseId + option.label" [disableRipple]="true"
                        [formControlName]="option.controlName">
                        {{option.label}}
                    </mat-checkbox>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="emds-col-12">
        <hr>
    </div>
</div>